import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2"; // <-- Import Swal
import Error from "./pages/Error";
import Landing from "./pages/Landing";
import Nin from "./pages/Nin";
import Instructions from "./pages/Instructions";
import BioData from "./pages/BioData";
import DocumentUpload from "./pages/DocumentUpload";
import Disclaimer from "./pages/Disclaimer";
import Residence from "./pages/Residence";
import Contact from "./pages/Contact";
import Prev from "./pages/Preview";
import Test from "./pages/Test";
import { WebcamCapture } from "./pages/Face";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./components/ProtectedRoute";

// 1. Create a component to clean up SweetAlert on route changes
const GlobalSweetAlertCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    // If there is an active SweetAlert when the page changes, forcefully close it
    if (Swal.isVisible()) {
      Swal.close();
    }
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      {/* 2. Place it inside the Router so it can access useLocation */}
      <GlobalSweetAlertCleanup />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="nin" element={<Nin />} />
        <Route path="instructions" element={<Instructions />} />
        <Route
          path="test"
          element={
            <ProtectedRoute>
              <Test />
            </ProtectedRoute>
          }
        />
        <Route
          path="contact"
          element={
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          }
        />
        <Route
          path="bio-data"
          element={
            <ProtectedRoute>
              <BioData />
            </ProtectedRoute>
          }
        />
        <Route
          path="face-capture"
          element={
            <ProtectedRoute>
              <WebcamCapture />
            </ProtectedRoute>
          }
        />
        <Route
          path="residence"
          element={
            <ProtectedRoute>
              <Residence />
            </ProtectedRoute>
          }
        />
        {/* Removed from active onboarding flow, but retained in router if needed later */}
        {/*
        <Route
          path="banking-info"
          element={
            <ProtectedRoute>
              <Banking />
            </ProtectedRoute>
          }
        />
        */}
        {/* New Document Upload Step (Replaces Banking) */}
        <Route
          path="document-upload"
          element={
            <ProtectedRoute>
              <DocumentUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="prev"
          element={
            <ProtectedRoute>
              <Prev />
            </ProtectedRoute>
          }
        />
        <Route path="disclaimer" element={<Disclaimer />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
};

export default App;
